import { NgModule } from '@angular/core';

import { SecondsInDaysPipe } from './seconds-in-days.pipe';

@NgModule({
  imports: [SecondsInDaysPipe],
  exports: [SecondsInDaysPipe],
})
export class SecondsInDaysModule {}
export { SecondsInDaysPipe } from './seconds-in-days.pipe';
